module.exports = new __parcel__URL__("incidents-task-one-illustration.f43c3365.png").toString();